import { Component, OnDestroy, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AESEncryptDecryptService} from '../../../_services/aesencrypt-decrypt.service';
import {Constants} from '../../../constants/constants';
import {StandbyService} from '../../../_services/standby.service';

@Component({
  selector: 'app-kiosk-container',
  templateUrl: './kiosk-container.component.html',
  styleUrls: ['./kiosk-container.component.scss'],
})
export class KioskContainerComponent implements OnInit, OnDestroy {
  isWebsite = false;

  constructor(private translate: TranslateService,
              private encryptService: AESEncryptDecryptService,
              private standbyService: StandbyService) {
    translate.setDefaultLang('English');
  }

  ngOnInit(): void {
    let role: string | null = null;
    try {
      role = this.encryptService.decrypt(sessionStorage.getItem('selectedRole'));
      this.isWebsite = role === Constants.WEBSITE;
    } catch (e) {}
    // Idle screensaver on the ordering screen — only for unattended customer
    // devices (kiosk / table), not the customer's own phone (QR/website) or
    // staff. No-op unless the merchant enabled kioskStandby.
    if (role === Constants.KIOSK || role === Constants.TABLE) {
      this.standbyService.start();
    }
  }

  ngOnDestroy(): void {
    this.standbyService.stop();
  }

}
